import { useState } from "react";
import { AdminDiscussDetailModel } from "../../../../hooks/community/models/AdminDiscussDetailModel";
import { AssignedManager, Subscription } from "../../../biography/models/FullUserProfileModel";
import { ProfileMemberCommunityDetails } from "./components/templates/ProfileMemberCommunityDetails";
import { ProfileMemeberCommunityList } from "./components/templates/ProfileMemeberCommunityList";


type Props = {
    userId: number;
    assignedManager?: AssignedManager;
    subscription?: Subscription;
}
export const ProfileMemberCommunity = ({ userId, assignedManager, subscription }: Props) => {
    const [ selected, setSelected ] = useState<AdminDiscussDetailModel | null>(null);
    
    return (
        <>
            {selected ? (
                <ProfileMemberCommunityDetails
                    id={selected.id}
                    onClose={() => setSelected(null)}
                />
            ): (
                <ProfileMemeberCommunityList
                    userId={userId}
                    onReview={setSelected}
                />
            )}
        </>
    )
}